var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVrPerson = function SvgVrPerson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    width: 400,
    height: 400,
    viewBox: "0, 0, 400,400",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0",
    d: "M186.038 9.805 C 145.748 20.367,129.684 69.797,156.194 101.636 C 189.553 141.701,254.708 120.557,257.774 68.672 C 260.073 29.752,223.725 -0.075,186.038 9.805 M141.339 132.003 C 132.362 135.137,125.596 141.266,121.519 149.959 L 119.196 154.911 118.947 209.708 C 118.698 264.213,118.707 264.527,120.617 268.472 C 123.974 275.405,127.830 277.177,140.332 277.530 L 150.893 277.828 151.018 281.548 C 151.086 283.594,151.220 306.563,151.316 332.589 C 151.554 397.597,146.903 391.964,200.344 391.964 C 239.157 391.964,239.561 391.921,244.526 387.222 C 250.155 381.895,250.000 383.566,250.000 328.154 L 250.000 277.679 259.866 277.679 C 272.797 277.679,278.843 274.688,281.376 267.040 C 283.648 260.179,282.828 157.636,280.453 151.565 C 277.804 144.796,270.867 137.278,263.918 133.645 L 258.482 130.804 202.232 130.593 C 149.871 130.397,145.661 130.495,141.339 132.003 ",
    stroke: "none",
    fillRule: "evenodd"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVrPerson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vr-person.fe944063.svg";
export { ForwardRef as ReactComponent };